import { useDatafeedSearchCauses } from '@givebacks/api/datafeed';
import { useBreakPoints } from 'core';
import { Search } from 'core/Components';
import { useNavigate } from 'react-router-dom';
import { CauseDetail, CauseStoreCard, ConditionalWrapper, Container, Stack, Title } from 'ui';

import classes from './ExploreCauses.module.css';
import { TrendingCauses } from './TrendingCauses/TrendingCauses';

const useSearchCauses = (searchTerm?: string) => {
  const { data: causes, isLoading } = useDatafeedSearchCauses({
    search: searchTerm ? encodeURIComponent(searchTerm) : undefined,
  });

  return { data: causes ?? [], isLoading: isLoading && !!searchTerm };
};

const ExploreCauses = () => {
  const { isSmallScreen } = useBreakPoints();
  const navigate = useNavigate();

  return (
    <Container size={'xl'}>
      <Stack gap={isSmallScreen ? 'lg' : 'xl'}>
        {/* On desktop, we want to show the blue box around the search bar */}
        <ConditionalWrapper
          condition={!isSmallScreen}
          wrapper={(children) => (
            <Stack gap="lg" className={classes.ExploreCauses__searchContainer}>
              <Title className={classes.ExploreCauses__searchContainerTitle} order={2}>
                Find the Causes You Love
              </Title>

              {children}
            </Stack>
          )}
        >
          <Search
            className={classes.ExploreCauses__search}
            useSearchFn={useSearchCauses}
            placeholder="Search by org name or location"
            optionKey={(cause) => cause.uuid}
            optionValue={(cause) => cause.uuid}
            renderOption={(cause) => (
              <CauseStoreCard
                className={classes.ExploreCauses__card}
                key={cause.uuid}
                direction="column"
                imgSrc={cause.thumbnail}
                title={cause.name}
                info={{
                  detail: (
                    <CauseDetail city={cause?.city} state={cause?.state} website={cause?.website} />
                  ),
                }}
                w="100%"
                isVerified={cause.stripe_connected}
              />
            )}
            onOptionSubmit={(val) => navigate(`${val}`)}
            showVerifiedBadge
          />
        </ConditionalWrapper>

        <TrendingCauses />
      </Stack>
    </Container>
  );
};
export { ExploreCauses };
